import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { SetChartMetrics } from './chart-metrics-state.actions';
import { CHART_METRICS_STATE_TOKEN, ChartMetricsStateModel } from './chart-metrics-state.models';

@Injectable()
@State<ChartMetricsStateModel>({
  name: CHART_METRICS_STATE_TOKEN,
  defaults: { metrics: [] },
})
export class ChartMetricsState {
  @Selector()
  static metrics({ metrics }: ChartMetricsStateModel) {
    return metrics;
  }

  @Action(SetChartMetrics)
  setChartMetrics({ patchState }: StateContext<ChartMetricsStateModel>, { metrics }: SetChartMetrics) {
    patchState({ metrics });
  }
}
